<template>
  <div id="wave-area" class="wave-area"></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["dataLst"],
  watch: {
    dataLst(val) {
      this.initArea();
    },
  },
  mounted() {
    this.initArea();
  },
  methods: {
    initArea() {
      let $this = this;
      let chartDom = document.getElementById("wave-area");
      let myChart = this.$echarts.init(chartDom, null, { renderer: "svg" });
      let option,
        dataLst = this.dataLst;
      option = {
        backgroundColor: "#fff",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line", // 默认为直线，可选为：'line' | 'shadow'
            lineStyle: {
              color: "#57617B",
            },
          },
        },
        legend: {
          // x: '50%',
          bottom: "1%",
          textStyle: {
            color: "#ffd285",
          },
          data: name,
        },
        grid: {
          borderWidth: 0,
          left: "5%",
          right: "10%",
          bottom: "5%",
          top: "10%",
          textStyle: {
            color: "#EDEEF0",
          },
          containLabel: true,
        },
        toolbox: {
          show: false,
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              color: "#EDEEF0",
            },
          },
          axisTick: { show: false },
          axisLabel: {
            textStyle: {
              color: "#A4A4A4",
              fontSize: "14px",
            },
          },
          boundaryGap: false,
          data: dataLst.xAxis,
        },
        yAxis: {
          // max: yAxisMax,
          axisLine: {
            lineStyle: {
              color: "#EDEEF0",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#EDEEF0",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#A4A4A4",
              fontSize: "14px",
            },
          },
          type: "value",
        },
        series: [{
          type: "line",
          symbolSize: 3,//标记的大小，可以设置成诸如 10 这样单一的数字，也可以用数组分开表示宽和高，例如 [20, 10] 表示标记宽为20，高为10[ default: 4 ]
          symbol: 'circle',//标记的图形。ECharts 提供的标记类型包括 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'
          smooth: true, //是否平滑曲线显示
          showSymbol: false, //是否显示 symbol, 如果 false 则只有在 tooltip hover 的时候显示
          areaStyle: {
            normal: {
              color: new $this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#428EF7'
              }, {
                offset: 0.8,
                color: 'rgba(255,255,255,0)'
              }], false),
              shadowColor: 'rgba(255,255,255, 0.1)',
              shadowBlur: 10,
              opacity: 0.3,
            }
          },
          itemStyle: {
            normal: {
              color: '#428EF7',
              lineStyle: {
                width: 1,
                type: 'solid' //'dotted'虚线 'solid'实线
              },
              borderColor: '#428EF7', //图形的描边颜色。支持的格式同 color
              borderWidth: 8,//描边线宽。为 0 时无描边。[ default: 0 ]
              barBorderRadius: 0,
              label: {
                show: false,
              },
              opacity: 0.5,
            }
          },
          data: dataLst.areaData,
        }],
      };
      myChart.setOption(option, true);
      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wave-area {
  width: 100%;
  height: 180px;
}
</style>